(function() {
  angular.module('admin')
  .factory('adminUsers', ['$resource', function($resource) {
    return $resource('users/:userId', {userId: '@userId'} ,{
      query:  {method: 'GET', isArray: false, url: 'users'},
      updateStatus:  {method: 'PATCH' },
      resendEmailVerification:  {method: 'GET', url: 'users/:userId/resendEmailVerification'},
      resetPassword:  {method: 'GET', url: 'users/:userId/resetPassword'},
      getAuditEvents: {method: 'GET', url: 'users/:userId/auditEvents', isArray: true}
    });
  }]);
})();
